//=require ../utils.js

class FP_Blog {
}

FP_Utils.onReady(function() {
	new FP_Blog();
});